import { Box, Card, Container, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import GaugeChart from 'react-gauge-chart'

import WmsCard from '../WMS/WmsCard'
import Image from 'mui-image'
import ReactSpeedometer from "react-d3-speedometer"
import { Constants } from '../../utils/Constants'
import ThermometerSvg from '../../assets/wmsIcon/ThermometerSvg'
import { AppThemeContext } from '../../context/AppThemeContext'

// 1.

// function TempMeter({ title, data, menuItem }) {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const MeterData = data[0]
//     // const [MeterData, setMeterData] = useState({})
//     // console.log('meterData', MeterData)
//     // console.log(typeof (parseInt(MeterData?.max_range)))
//     const [MAXVAL, setMAXVAL] = useState(parseInt(MeterData?.max_range))
//     // useEffect(() => {
//     //     setMeterData({ ...Data })
//     // }, [Data])

//     const { palette, breakpoints } = useTheme()
//     const lgs = useMediaQuery(breakpoints.down('lg'))

//     console.log("meterDatareact",MeterData?.max_range)

//     return (
//         <Box component={Card} height={'100%'}>
//             <Box sx={{ visibility: title == 'Multiple Module Temperature' ? 'hidden' : 'unset' }}>
//                 {/* <Container>
//                     <GaugeChart id="gauge-chart5"
//                         nrOfLevels={420}
//                         arcsLength={[0.3, 0.5, 0.2]}
//                         colors={['#FED7AA', '#FB923C', '#EA580C']}
//                         percent={title == "Solar Insolation" ? MeterData?.['Solar Insolation'] : MeterData?.LIVE_VALUE}
//                         textColor={palette.primary.dark}
//                         cornerRadius={0}
//                         hideText
//                         animate={false}
//                         style={{ width: 'auto', margin: 'auto' }}
//                         arcPadding={0.0}
//                     />
//                 </Container> */}

//                 <Box sx={{ justifyContent: 'center', display: "flex" }}>
//                     <div>
//                         {/* {console.log(MeterData?.max_range, typeof (+MeterData?.max_range))} */}

//                         <ReactSpeedometer
//                             // width={400}
//                             paddingHorizontal={10}
//                             paddingVertical={20}
//                             height={200}
//                             segments={2}
//                             value={title === "Solar Insolation" ? MeterData?.['Solar Insolation'] : MeterData?.LIVE_VALUE}
//                             currentValueText={MeterData?.LIVE_VALUE?.length <= 0 || MeterData?.LIVE_VALUE == undefined ? "0" : title === "Solar Insolation" ? MeterData?.['Solar Insolation'] + ' ' + MeterData?.UNIT : MeterData?.LIVE_VALUE + ' ' + MeterData?.UNIT}
//                             minValue={0}
//                             maxValue={
//                                 title === "Solar Irradiance" ? 2500 : title === "Wind Speed" || title === "Module Temperature" || title === "Ambient Temperature" || title === "Humidity" ? 100 : title === "Solar Insolation" ? 10 : title === "RAIN" ? 1500 : null
//                             }
//                             segmentColors={['#FED7AA', '#FB923C', '#EA580C']}
//                             needleColor={palette.primary.main}
//                             textColor={palette.primary.main}
//                         />



//                     </div>
//                 </Box>

//                 {/* <Typography component={Paper} bgcolor={palette.primary.light} width={'10rem'} m={'auto'} textAlign={'center'} variant='h5'>{MeterData?.LIVE_VALUE ? `${MeterData?.LIVE_VALUE} ${MeterData?.UNIT}` : '____'}</Typography> */}

//                 <Stack sx={{ mx: 2 }}>
//                     <WmsCard
//                         // 1.
//                         // StartIcon={
//                         //     // <Image
//                         //     //     src={}
//                         //     //     width={lgs ? 80 : 60}
//                         //     //     height={"fit-content"}
//                         //     // />
//                         //     Constants()[title] ? Constants()[title] : <Image width={90} height={'auto'} src={require('../../assets/img/blank.png')} />
//                         // }

//                         // 2.

//                         // StartIcon={
//                         //     title?.toLowerCase().startsWith("solar") ? (
//                         //         <Image width={70} height={'auto'} src={require('../../assets/img/logos/sun.png')} />
//                         //     ) : Constants()[title] ? (
//                         //         Constants()[title]
//                         //     ) : (
//                         //         <Image width={90} height={'auto'} src={require('../../assets/img/blank.png')} />
//                         //     )
//                         // }

//                         StartIcon={
//                             /^WTI[\s-]?/i.test(title) || /^OTI[\s-]?/i.test(title) ? (

//                                 <ThermometerSvg color={PrimaryColor} height="4.2rem" width="4.2rem" />


//                             ) : title.startsWith('Solar') ? (
//                                 Constants()['Solar Insolation']
//                             ) : Constants()[title] ? (
//                                 Constants()[title]
//                             ) : (
//                                 <Image width={70} height={'auto'} src={require('../../assets/img/blank.png')} />
//                             )
//                         }

//                         WmsCardStyle={{ border: 0, flex: 1, backgroundColor: '#FDF8E4' }}
//                         title={title}
//                         menuItem={menuItem}
//                         boldTitle={title == "Solar Insolation" ? MeterData?.['Solar Insolation'] + " " + MeterData?.UNIT : MeterData?.LIVE_VALUE ? MeterData?.LIVE_VALUE + ' ' + MeterData?.UNIT : '____'}
//                         LiveDate={MeterData?.LIVE_DATE_TIME}
//                         minValue={MeterData?.MIN_VALUE}
//                         minDate={MeterData?.MIN_DATE_TIME}
//                         maxValue={MeterData?.MAX_VALUE}
//                         maxDate={MeterData?.MAX_DATE_TIME}
//                         avgValue={MeterData?.AVG_VALUE}
//                         rightTitle={title == 'Wind Direction' ? null : MeterData?.UD}
//                     />
//                 </Stack>

//             </Box>

//         </Box>
//     )
// }

// export default TempMeter

// 2.

// function TempMeter({ title, data, menuItem }) {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const MeterData = data[0];

//     // Initialize min and max value from data (fallbacks included)
//     const [MINVAL, setMINVAL] = useState(parseInt(MeterData?.min_range) || 0);
//     const [MAXVAL, setMAXVAL] = useState(parseInt(MeterData?.max_range) || 100);

//     useEffect(() => {
//         // Update min range
//         if (MeterData?.min_range) {
//             const minVal = parseInt(MeterData.min_range);
//             if (!isNaN(minVal)) {
//                 setMINVAL(minVal);
//             }
//         }

//         // Update max range
//         if (MeterData?.max_range) {
//             const maxVal = parseInt(MeterData.max_range);
//             if (!isNaN(maxVal) && maxVal > 0) {
//                 setMAXVAL(maxVal);
//             }
//         }
//     }, [MeterData?.min_range, MeterData?.max_range, data]);

//     const { palette, breakpoints } = useTheme();
//     const lgs = useMediaQuery(breakpoints.down('lg'));

//     // Get value based on title
//     const currentValueRaw = title === "Solar Insolation"
//         ? MeterData?.['Solar Insolation']
//         : MeterData?.LIVE_VALUE;

//     const currentValue = parseFloat(currentValueRaw);
//     const safeValue = isNaN(currentValue) ? 0 : currentValue;

//     const safeMin = isNaN(MINVAL) ? 0 : MINVAL;
//     const safeMax = isNaN(MAXVAL) || MAXVAL <= safeMin ? safeMin + 100 : MAXVAL;

//     // Clamp value within range
//     const clampedValue = Math.min(Math.max(safeValue, safeMin), safeMax);

//     // console.log("meterDatareact", MeterData?.max_range)

//     return (
//         <Box component={Card} height={'100%'}>
//             <Box sx={{ visibility: title == 'Multiple Module Temperature' ? 'hidden' : 'unset' }}>
              

//                 <Box sx={{ justifyContent: 'center', display: "flex" }}>
//                     <div>
//                         {/* {console.log(MeterData?.max_range, typeof (+MeterData?.max_range))} */}
//                         <ReactSpeedometer
//                         key={`${safeMin}-${safeMax}-${clampedValue}`} // Re-render on value change
//                         paddingHorizontal={10}
//                         paddingVertical={20}
//                         height={200}
//                         segments={2}
//                         value={clampedValue}
//                         currentValueText={`${clampedValue} ${MeterData?.UNIT || ''}`}
//                         minValue={safeMin}
//                         maxValue={safeMax}
//                         segmentColors={['#FED7AA', '#FB923C', '#EA580C']}
//                         needleColor={palette.primary.main}
//                         textColor={palette.primary.main}
//                     />



//                     </div>
//                 </Box>

//                 {/* <Typography component={Paper} bgcolor={palette.primary.light} width={'10rem'} m={'auto'} textAlign={'center'} variant='h5'>{MeterData?.LIVE_VALUE ? `${MeterData?.LIVE_VALUE} ${MeterData?.UNIT}` : '____'}</Typography> */}

//                 <Stack sx={{ mx: 2 }}>
//                     <WmsCard
//                         // 1.
//                         // StartIcon={
//                         //     // <Image
//                         //     //     src={}
//                         //     //     width={lgs ? 80 : 60}
//                         //     //     height={"fit-content"}
//                         //     // />
//                         //     Constants()[title] ? Constants()[title] : <Image width={90} height={'auto'} src={require('../../assets/img/blank.png')} />
//                         // }

//                         // 2.

//                         // StartIcon={
//                         //     title?.toLowerCase().startsWith("solar") ? (
//                         //         <Image width={70} height={'auto'} src={require('../../assets/img/logos/sun.png')} />
//                         //     ) : Constants()[title] ? (
//                         //         Constants()[title]
//                         //     ) : (
//                         //         <Image width={90} height={'auto'} src={require('../../assets/img/blank.png')} />
//                         //     )
//                         // }

//                         StartIcon={
//                             /^WTI[\s-]?/i.test(title) || /^OTI[\s-]?/i.test(title) ? (

//                                 <ThermometerSvg color={PrimaryColor} height="4.2rem" width="4.2rem" />


//                             ) : title.startsWith('Solar') ? (
//                                 Constants()['Solar Insolation']
//                             ) : Constants()[title] ? (
//                                 Constants()[title]
//                             ) : (
//                                 <Image width={70} height={'auto'} src={require('../../assets/img/blank.png')} />
//                             )
//                         }

//                         WmsCardStyle={{ border: 0, flex: 1, backgroundColor: '#FDF8E4' }}
//                         title={title}
//                         menuItem={menuItem}
//                         boldTitle={title == "Solar Insolation" ? MeterData?.['Solar Insolation'] + " " + MeterData?.UNIT : MeterData?.LIVE_VALUE ? MeterData?.LIVE_VALUE + ' ' + MeterData?.UNIT : '____'}
//                         LiveDate={MeterData?.LIVE_DATE_TIME}
//                         minValue={MeterData?.MIN_VALUE}
//                         minDate={MeterData?.MIN_DATE_TIME}
//                         maxValue={MeterData?.MAX_VALUE}
//                         maxDate={MeterData?.MAX_DATE_TIME}
//                         avgValue={MeterData?.AVG_VALUE}
//                         rightTitle={title == 'Wind Direction' ? null : MeterData?.UD}
//                     />
//                 </Stack>

//             </Box>

//         </Box>
//     )
// }

// export default TempMeter

// 3.

function TempMeter({ title, data, menuItem }) {
    const { PrimaryColor } = useContext(AppThemeContext)
    const MeterData = data[0] || {}

    // Parse min/max for chart
    const MINVAL = !isNaN(parseFloat(MeterData.min_range)) ? parseFloat(MeterData.min_range) : null
    const MAXVAL = !isNaN(parseFloat(MeterData.max_range)) ? parseFloat(MeterData.max_range) : null

    // Current value (fallback 0 if invalid)
    const currentValueRaw = title === "Solar Insolation"
        ? MeterData['Solar Insolation']
        : MeterData.LIVE_VALUE

    const currentValue = !isNaN(parseFloat(currentValueRaw)) ? parseFloat(currentValueRaw) : 0

    const hasValidData =
        !isNaN(parseFloat(MeterData.min_range)) &&
        !isNaN(parseFloat(MeterData.max_range)) &&
        !isNaN(parseFloat(currentValueRaw))

    const { palette, breakpoints } = useTheme()
    useMediaQuery(breakpoints.down('lg'))

    return (
        <Box component={Card} height={'100%'}>
            <Box sx={{ visibility: title === 'Multiple Module Temperature' ? 'hidden' : 'unset' }}>
                {/* Chart always render */}
                <Box sx={{ justifyContent: 'center', display: "flex" }}>
                    <ReactSpeedometer
                        key={`${MINVAL}-${MAXVAL}-${currentValue}`}
                        paddingHorizontal={10}
                        paddingVertical={20}
                        height={200}
                        segments={10}
                        value={currentValue}
                        minValue={MINVAL}
                        maxValue={MAXVAL}
                        segmentColors={['#FED7AA', '#FB923C', '#EA580C']}
                        needleColor={palette.primary.main}
                        textColor={palette.primary.main}
                        // Always show unit, even if value invalid
                        currentValueText={currentValueRaw ? `${currentValueRaw} ${MeterData.UNIT || ''}` : MeterData.UNIT || ''}
                    />
                </Box>

                {/* WmsCard info */}
                <Stack sx={{ mx: 2 }}>
                    <WmsCard
                        StartIcon={
                            /^WTI[\s-]?/i.test(title) || /^OTI[\s-]?/i.test(title) ? (
                                <ThermometerSvg color={PrimaryColor} height="4.2rem" width="4.2rem" />
                            ) : title.startsWith('Solar') ? (
                                Constants()['Solar Insolation']
                            ) : Constants()[title] ? (
                                Constants()[title]
                            ) : (
                                <Image width={70} height={'auto'} src={require('../../assets/img/blank.png')} />
                            )
                        }
                        WmsCardStyle={{ border: 0, flex: 1, backgroundColor: '#FDF8E4' }}
                        title={title}
                        menuItem={menuItem}
                        boldTitle={hasValidData
                            ? currentValueRaw + ' ' + (MeterData.UNIT || '')
                            : '____'}
                        LiveDate={MeterData.LIVE_DATE_TIME}
                        minValue={hasValidData ? MINVAL : null}
                        minDate={MeterData.MIN_DATE_TIME}
                        // maxValue={hasValidData ? MAXVAL : null}
                        maxDate={MeterData.MAX_DATE_TIME}
                        avgValue={MeterData.AVG_VALUE}
                        rightTitle={title === 'Wind Direction' ? null : MeterData.UD}
                    />
                </Stack>
            </Box>
        </Box>
    )
}

export default TempMeter